import React from 'react';

const Logo = props => {
  return <img alt="Logo" src="/static/icon_logo.svg" {...props} />;
};

export default Logo;
